(ns rothko.form2.input.component
  (:require [rothko.dom.event :as event]
            [rothko.form2.component :as form]
            [rothko.form2.label.component :as label]
            [rothko.form2.validation :as validation]
            [rothko.form2.validation-message.component :as validation-message]))

(defn number-parser
  [on-result]
  (fn [value]
    (let [parsed (js/Number.parseInt value 10)]
      (if (js/Number.isNaN parsed)
        (on-result nil)
        (on-result parsed)))))

(defn field
  [{:keys [appearance
           ::form/disabled?
           ::form/name
           ::form/set-value-cleanly!
           ::form/set-dirty!
           ::form/value
           ::validation/valid?
           ::auto-focus?
           ::placeholder
           ::type]
    :as field-props}]
  ;; TODO rothko#210 use defcomp for input and assert props there
  (assert (not (nil? type)))
  [:div.form__input
   [label/component field-props]
   [(case type
      :textarea :textarea
      :input)
    {:auto-focus auto-focus?
     ;; TODO rothko#229 disabled? should be an appearance
     :class (cond-> appearance
              disabled? (conj :disabled))
     :disabled disabled?
     :type type
     :id name
     :name name
     :on-blur set-dirty!
     :on-change (event/dom-event
                 (if (= type :number)
                   (number-parser set-value-cleanly!)
                   set-value-cleanly!))
     :placeholder placeholder
     :value value}]
   [validation-message/component field-props]])
